<template>
  <el-button
    :color="color || themeColor"
    v-bind="$attrs"
    :icon="isElementIcon(icon)"
    type="primary"
  >
    <template v-for="(value, slotName) in $slots" #[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <!--按钮图标-->
    <template #icon v-if="icon && !ElementPlusIconsVue[icon]">
      <SvgIcon :name="icon" />
    </template>
    <slot></slot>
  </el-button>
</template>

<script setup>
import SvgIcon from "@/components/Global/SvgIcon.vue";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { getCssVar } from "@/utils/themed.js";

const themeColor = getCssVar("--themed-color");
defineProps(["icon", "color"]);

// 判断是否是饿了么的 icon 图标
const isElementIcon = (icon) => (ElementPlusIconsVue[icon] ? icon : "");
</script>

<style scoped lang="scss">
.el-button--primary {
  color: #fff;
  &.is-link {
    color: #6fcaf7;
  }
}
</style>
